import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { getPlaybookType } from './helpers';
import { loadPlaybooks } from './store/playbooks/actions';

import PlaybookTypes from './playbook_types';
import LoadingSpinner from 'components/loading_spinner';

import Playbook from './playbook';

import './styles.scss';

export function ConnectedPlaybooksConfig({ playbookType, loadPlaybooks, playbooks, stage, status }) {
  useEffect(() => {
    loadPlaybooks();
  }, []);

  if (!playbooks) {
    return <LoadingSpinner/>;
  }

  return (
    <div className="playbooks-config">
      <PlaybookTypes/>
      <Playbook
        playbook={playbooks.find(playbook => getPlaybookType(playbook) === playbookType)}
        playbooks={playbooks}
        stage={stage}
        status={status}
      />
    </div>
  );
}

ConnectedPlaybooksConfig.propTypes = {
  loadPlaybooks: PropTypes.func.isRequired,
  playbooks: PropTypes.array,
  playbookType: PropTypes.string.isRequired,
  stage: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  playbooks: state.playbooks,
  playbookType: state.playbookType,
  stage: state.stage,
  status: state.status,
});

const mapDispatchToProps = {
  loadPlaybooks,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedPlaybooksConfig);
